var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDeviceNvrOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 23.2C12.2542 22.4681 12.9959 22 13.8091 22H56.1909C57.0041 22 57.7458 22.4681 58.1 23.2L64.8 37.05C64.9314 37.3216 65 37.6193 65 37.9211V48C65 49.1046 64.1046 50 63 50H7C5.89543 50 5 49.1046 5 48V37.9211C5 37.6193 5.06857 37.3216 5.2 37.05L11.9 23.2Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3333 36H6.66667C5.74619 36 5 36.7163 5 37.6V48.4C5 49.2837 5.74619 50 6.66667 50H63.3333C64.2538 50 65 49.2837 65 48.4V37.6C65 36.7163 64.2538 36 63.3333 36Z",
    fill: "url(#paint0_linear_nvr_off)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 27.5H56",
    stroke: "#B4B4B4",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 40H15.5C14.6716 40 14 40.6716 14 41.5C14 42.3284 14.6716 43 15.5 43H19C19.8284 43 20.5 42.3284 20.5 41.5C20.5 40.6716 19.8284 40 19 40Z",
    fill: "#C5C5C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40H25V44H29V40Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 40H31V44H35V40Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41 40H37V44H41V40Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47 40H43V44H47V40Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40H49V44H53V40Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40H55V44H59V40Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29.5H42",
    stroke: "#8E8E8E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 13,
    r: 5,
    fill: "#DB0046"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_nvr_off",
    x1: 35,
    y1: 36,
    x2: 35,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeviceNvrOff);
export default __webpack_public_path__ + "static/media/img_device_nvr_off.e70133230bc1af98e235dbd5f73a87c3.svg";
export { ForwardRef as ReactComponent };